import { render, staticRenderFns } from "./ProductVariant.vue?vue&type=template&id=144039d9&scoped=true&"
import script from "./ProductVariant.vue?vue&type=script&lang=js&"
export * from "./ProductVariant.vue?vue&type=script&lang=js&"
import style0 from "./ProductVariant.vue?vue&type=style&index=0&id=144039d9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144039d9",
  null
  
)

export default component.exports